//Cart Clear on currency change
// document.addEventListener("DOMContentLoaded", function () {
//   const gShopCurrency = document.body.dataset.shopCurrency;
//   const currentShopCurrency = localStorage.getItem('currentShopCurrency');
//   if(!currentShopCurrency){
//     localStorage.setItem('currentShopCurrency', gShopCurrency);
//   }else{
//     if(gShopCurrency !== currentShopCurrency){
//       localStorage.setItem('currentShopCurrency', gShopCurrency);
//       const savedMarket = Shopify.country
//       fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         if (cart.item_count > 0) {
//           return fetch('/cart/update.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ 
//               attributes: { 
//                 '_Market': savedMarket 
//               } 
//             })
//           })
//           .then(() => fetch('/cart/clear.js', { method: 'POST' }))
//           .then(() => location.reload());
//         }
//       })
//       .catch(error => console.error('Error updating cart:', error));
//     }
//   }
// });
document.addEventListener("DOMContentLoaded", function () {
  const gShopCurrency = document.body.dataset.shopCurrency;
  const currentShopCurrency = localStorage.getItem('currentShopCurrency');
  const savedMarket = (window.Shopify && window.Shopify.country) ? window.Shopify.country : 'US';
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const needsAttributeUpdate = cart.attributes['_Market'] !== savedMarket;
      let needsToClearCart = false;
      if (!currentShopCurrency) {
        localStorage.setItem('currentShopCurrency', gShopCurrency);
      }else if (gShopCurrency !== currentShopCurrency) {
        localStorage.setItem('currentShopCurrency', gShopCurrency);
        if (cart.item_count > 0) {
          needsToClearCart = true;
        }
      }
      if (needsToClearCart) {
        return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { '_Market': savedMarket } })
          })
          .then(() => fetch('/cart/clear.js', { method: 'POST' }))
          .then(() => location.reload());
      }else if (needsAttributeUpdate) {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: { '_Market': savedMarket } })
        });
      }
    })
    .catch(error => console.error('Error in cart logic:', error));
});

// Header Height Top Minus
const headersettop = () => {
  const modal = document.querySelector(".search-modal");
  const header = document.querySelector("header");
  if (modal && header) modal.style.top = `${header.offsetHeight}px`;
};
headersettop();
addEventListener("resize", headersettop);

document.addEventListener("DOMContentLoaded", function () {
  const searchBtn = document.querySelector(".search__button-mobile-sticky");

  if (searchBtn) {
    searchBtn.addEventListener("click", function () {
      const parent = searchBtn.closest(".shopify-section-header-sticky");
      if (parent) {
        const searchInfo = parent.querySelector(".block_mobile-search-info");
        if (searchInfo) {
          searchInfo.classList.toggle("search-active");
        }
      }
    });
  }
});



document.addEventListener("DOMContentLoaded", function () {
  // Announcement Bar Swiper
  const announcementBarSwiper = document.querySelectorAll(
    ".block__announcement-bar_swiper"
  );

  if (announcementBarSwiper.length > 0) {
    announcementBarSwiper.forEach((announcementBarList) => {
      const parent = announcementBarList.closest(".block__announcement-bar");
      const nextBtn = parent.querySelector(".announcement-bar_next_btn");
      const prevBtn = parent.querySelector(".announcement-bar_perv_btn");

      new Swiper(announcementBarList, {
        direction: "horizontal",
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        allowTouchMove: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      });
    });
  }

  // Announcement Bar countdown JS
document.addEventListener("DOMContentLoaded", function () {
  (function () {
    const second = 1000,
      minute = second * 60,
      hour = minute * 60,
      day = hour * 24;

    const container = document.querySelector(".container[data-countdown]");
    const countdownRaw =
      container?.getAttribute("data-countdown") || "29-11-2025";

    function parseDMY(dateStr) {
      const [dd, mm, yyyy] = dateStr.split("-");
      return new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
    }

    const countDown = parseDMY(countdownRaw).getTime();

    const x = setInterval(function () {
      const now = new Date().getTime();
      const distance = countDown - now;

      const daysEl = document.getElementById("days");
      const hoursEl = document.getElementById("hours");
      const minutesEl = document.getElementById("minutes");
      const secondsEl = document.getElementById("seconds");

      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
        clearInterval(x);
        return;
      }

      if (distance < 0) {
        document.getElementById("countdown").style.display = "none";
        document.getElementById("closed-message").style.display = "block";
        clearInterval(x);
        return;
      }

      daysEl.innerText = String(Math.floor(distance / day)).padStart(2, "0");
      hoursEl.innerText = String(Math.floor((distance % day) / hour)).padStart(2, "0");
      minutesEl.innerText = String(Math.floor((distance % hour) / minute)).padStart(2, "0");
      secondsEl.innerText = String(Math.floor((distance % minute) / second)).padStart(2, "0");
    }, 1000);
  })();
});

  // schema js collection-grid JS

  const collectionGrids = document.querySelectorAll(
    ".block__collection_grid-swiper"
  );

  if (collectionGrids.length > 0) {
    collectionGrids.forEach((collectionGrid) => {
      const sliderColumns =
        parseInt(collectionGrid.dataset.sliderColumns, 10) || 4;

      new Swiper(collectionGrid, {
        direction: "horizontal",
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: true,
        navigation: {
          nextEl: ".our-collection_next_btn",
          prevEl: ".our-collection_perv_btn",
        },
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 0,
            centeredSlides: false,
            loop: true,
          },
          375: {
            slidesPerView: 1.64,
            spaceBetween: 8,
            centeredSlides: true,
            loop: false,
          },
          749: {
            slidesPerView: 3,
            spaceBetween: 8,
            loop: false,
            centeredSlides: false,
          },
          1196: {
            slidesPerView: sliderColumns,
            spaceBetween: 8,
            loop: false,
            centeredSlides: false,
          },
        },
      });
    });
  }

  // our-essentials Js

  const ourEssentials = document.querySelectorAll(
    ".block__our-essentials-swiper"
  );

  if (ourEssentials.length > 0) {
    ourEssentials.forEach((ourEssentialsList) => {
      new Swiper(ourEssentialsList, {
        direction: "horizontal",
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: true,
        navigation: {
          nextEl: ".our-essentials_next_btn",
          prevEl: ".our-essentials_perv_btn",
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 3,
            centeredSlides: false,
            loop: true,
          },
          375: {
            slidesPerView: 3.1,
            spaceBetween: 3,
            centeredSlides: true,
            loop: false,
          },
          991: {
            slidesPerView: 4,
            spaceBetween: 8,
            loop: false,
            centeredSlides: false,
          },
          1196: {
            slidesPerView: 4,
            spaceBetween: 8,
            loop: false,
            centeredSlides: false,
          },
        },
      });
    });
  }

  // product-invisible-set JS

  const invisibleSection = document.querySelectorAll(
    ".block__invisible_sec_swiper"
  );

  if (invisibleSection.length > 0) {
    invisibleSection.forEach((invisibleSecList) => {
      const parent = invisibleSecList.closest(".block__invisible-set-group");
      const nextBtn = parent.querySelector(".invisible_sec_next_btn");
      const prevBtn = parent.querySelector(".invisible_sec_perv_btn");

      new Swiper(invisibleSecList, {
        direction: "horizontal",
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      });
    });
  }

  // invisible-set
  const invisibleSetSwiper = document.querySelectorAll(
    ".block__invisible_set-swiper"
  );
  if (invisibleSetSwiper.length > 0) {
    invisibleSetSwiper.forEach((invisibleSetList) => {
      const parent = invisibleSetList.closest(".block__invisible-set-group");
      const nextBtn = parent.querySelector(".invisible_set_next_btn");
      const prevBtn = parent.querySelector(".invisible_set_perv_btn");

      new Swiper(invisibleSetList, {
        direction: "horizontal",
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
      });
    });
  }
  
document.querySelectorAll('[id^="shopify-section-template--"][id*="__featured_collection_"]').forEach((section) => {
  const swiperEl = section.querySelector(".block__collections-products-swiper");
  const nextEl = section.querySelector(".block__featuredproduct-next-arrow");
  const prevEl = section.querySelector(".block__featuredproduct-prev-arrow");

  if (swiperEl && nextEl && prevEl) {
    new Swiper(swiperEl, {
      direction: "horizontal",
      slidesPerView: 1,
      spaceBetween: 0,
      centeredSlides: true,
      centeredSlidesBounds: true,
      loop: false,
      navigation: {
        nextEl,
        prevEl,
      },
      breakpoints: {
        320: {
          slidesPerView: 1.5,
          spaceBetween: 3,
          centeredSlides: true,
          loop: false,
        },
        375: {
          slidesPerView: 2,
          spaceBetween: 3,
          centeredSlides: true,
          loop: false,
        },
        749: {
          slidesPerView: 3,
          spaceBetween: 8,
          loop: false,
          centeredSlides: false,
        },
        1196: {
          slidesPerView: 4,
          spaceBetween: 8,
          loop: true,
          centeredSlides: false,
        },
      },
    });
  }
});

  // Product Swiper
  const productSwiper = document.querySelectorAll(".block__product-swiper");

  if (productSwiper.length > 0) {
    productSwiper.forEach((productSwiperList) => {
      new Swiper(productSwiperList, {
        direction: "horizontal",
        slidesPerView: 1,
        spaceBetween: 20,
        centeredSlides: true,
        centeredSlidesBounds: true,
        loop: false,
        navigation: {
          nextEl: ".block__product-next-arrow",
          prevEl: ".block__product-prev-arrow",
        },
        breakpoints: {
          320: {
            slidesPerView: 2.2,
            spaceBetween: 6,
            centeredSlides: true,
            loop: false,
          },
          400: {
            slidesPerView: 2.2,
            spaceBetween: 8,
            centeredSlides: true,
            loop: false,
          },
          749: {
            slidesPerView: 3,
            spaceBetween: 8,
            loop: false,
            centeredSlides: false,
          },
          1196: {
            slidesPerView: 2,
            spaceBetween: 8,
            loop: false,
            centeredSlides: false,
          },
        },
      });
    });
  }

  const menuInfo = document.querySelector(".block_menu-right-info");
  const allBanners = menuInfo?.querySelectorAll(".block_banner-child-links");
  if (menuInfo && allBanners.length) {
    document.querySelectorAll(".mega-menu__link--level-2").forEach((link) => {
      link.addEventListener("mouseenter", () => {
        const dataId = link.id;
        const target = menuInfo.querySelector(`.${dataId}`);

        if (!target) return;

        // Only change visibility if not already visible
        allBanners.forEach((banner) => {
          banner.classList.toggle("hidden", banner !== target);
        });
      });
    });
  }

  function setupMobileMenuToggle() {
    if (window.matchMedia("(max-width: 990px)").matches) {
      document
        .querySelectorAll(".block_child-menu-links")
        .forEach(function (element) {
          element.addEventListener("click", function (event) {
            // Prevent toggle if the clicked element is an <a> or inside one
            if (event.target.tagName === "A" || event.target.closest("a")) {
              return;
            }

            event.preventDefault();

            const li = element.closest("li");
            if (li) {
              const target = li.querySelector(".block_banner-child-links");
              if (target) {
                target.classList.toggle("hidden");
              }
            }
          });
        });
    }
  }

  setupMobileMenuToggle();
});

// Quantity not allow dimestional
document.querySelectorAll('.quantity__input').forEach(input => {
    input.addEventListener('input', e => {
    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 3);
  });
      input.addEventListener('paste', e => {
      const data = (e.clipboardData || window.clipboardData).getData('text');
      if (!/^\d{1,3}$/.test(data)) e.preventDefault();
  });
});

// Contact Us page Chat with us Trigger Click
document.addEventListener('click', function (e) {
    if (e.target.closest('.contact-chat-with-us')) {
        document.querySelector('#gladlyChatDragHandle')?.click();
    }
});

// Location Smooth Redirection for Desktop Only (989px+)
document.addEventListener('click', function (e) {
  if (window.innerWidth >= 990) {
    const locationtrigger = e.target.closest('.header__location-inner');
    const locationtarget = document.querySelector('#section-visit-our-stores-location-main');
    if (locationtrigger && locationtarget) {
      e.preventDefault();
      locationtarget.scrollIntoView({ behavior: 'smooth' });
    }
  }
});


// Filter Js For Mobile [Collection Page]
document.addEventListener("click", function (event) {
  const summary = event.target.closest(".mobile-facets__summary");
  if (summary) {
    const details = summary.closest(".mobile-facets__details");
    if (details) {
      const list = details.querySelector(".mobile-facets__list");
      const arrow = details.querySelector(".mobile-facets__arrow");
      if (list) {
        if (list.style.maxHeight) {
          list.style.maxHeight = null;
        } else {
          list.style.maxHeight = list.scrollHeight + "px";
        }
      }
      if (arrow) {
        arrow.classList.toggle("active");
      }
    }
  }
});

function updatePaddingTop() {
  if (window.innerWidth <= 899) {
    const activeFacets = document.querySelector(".active-facets-mobile");
    const productDetails = document.querySelector(".products-details.mobile-facets-only");

    if (activeFacets && productDetails) {
      const activeHeight = activeFacets.offsetHeight;
      productDetails.style.marginTop = (activeHeight) + "px";
    }
  }
}
window.addEventListener("load", updatePaddingTop);
window.addEventListener("resize", updatePaddingTop);


// honeypot JS For newsletter
document.addEventListener("DOMContentLoaded", function () {
  const newsletterForms = document.querySelectorAll('form#ContactFooter');
  newsletterForms.forEach(function (form) {
    const honeypot = form.querySelector('input[name="website"]');
    form.addEventListener("submit", function (e) {
      if (honeypot && honeypot.value.trim() !== "") {
        e.preventDefault();
      }
    }, true);
  });
});

// Location JS
document.addEventListener("DOMContentLoaded", function () {
  if (!window.location.pathname.includes('/pages/store-locations/')) {    return;
  }
  const moveBlock = () => {
    const storeContact = document.querySelector('.store-contact');
    const appBlock = document.querySelector('[data-app-block]');

    if (storeContact && appBlock) {
      storeContact.insertAdjacentElement('afterend', appBlock);
      return true;
    }
    return false;
  };
  if (!moveBlock()) {
    const observer = new MutationObserver(() => {
      if (moveBlock()) {
        observer.disconnect();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
});


document.addEventListener('change', function (event) {
  if (event.target && event.target.id === 'gift-checkbox') {
    const messageWrapper = document.getElementById('gift-message-wrapper');
    const messageInput = document.getElementById('gift-message');

    if (messageWrapper) {
      if (event.target.checked) {
        messageWrapper.style.display = 'block';
      } else {
        messageWrapper.style.display = 'none';
        if (messageInput) messageInput.value = '';
      }
    }
  }

});